// src/pages/crm/ViewLeads.js
import React, { useState, useEffect } from "react";
import Header from "../../components/Header";
import API_BASE_URL from "../../config";
import { Link } from "react-router-dom";
import Select from "react-select";
import { Modal, Button } from "react-bootstrap";
import { useLocation } from "react-router-dom";


const ViewLeads = () => {
  const [leads, setLeads] = useState([]);
  const [keyword, setKeyword] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [offset, setOffset] = useState(0);
  const limit = 10;
  const [hasMore, setHasMore] = useState(true);
  const [totalLeads, setTotalLeads] = useState(0);
  const [selectedLead, setSelectedLead] = useState(null);
  const [showContactModal, setShowContactModal] = useState(false);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [searching, setSearching] = useState(false);
  const [isManualSearch, setIsManualSearch] = useState(false);

  const fetchLeads = async (search = "", newOffset = 0, reset = false) => {
    if (!hasMore && newOffset !== 0 && !reset) return;

    setIsLoading(true);
    try {
      const response = await fetch(
        `${API_BASE_URL}/crm/get_leads_list?search=${encodeURIComponent(search)}&limit=${limit}&offset=${newOffset}`,
      );
      const result = await response.json();
      const fetchedLeads = result.data || [];

      // Stop if no more records
      if (fetchedLeads.length < limit) {
        setHasMore(false);
      }

      setLeads((prev) => (reset ? fetchedLeads : [...prev, ...fetchedLeads]));
      setOffset(newOffset);
      setTotalLeads(result.total);
    } catch (error) {
      console.error("Error fetching leads:", error);
    } finally {
      setIsLoading(false);
      setSearching(false);
      setIsManualSearch(false); // reset flag
    }
  };

  const location = useLocation();

  useEffect(() => {
  document.title = "View Leads | Webyappy";
  
  const params = new URLSearchParams(location.search);
  const urlSearch = params.get("search");

  // ⛔ Only load default if there's no search term
  if (!urlSearch) {
    fetchLeads("", 0, true);
  }
}, [location.search]);

  

useEffect(() => {
  const params = new URLSearchParams(location.search);
  const urlSearch = params.get("search");

  if (urlSearch) {
    const sanitized = urlSearch.trim().replace(/\s+/g, " ");
    setKeyword(urlSearch); // show in input
    setIsManualSearch(true);
    setSearching(true);
    setOffset(0);
    setHasMore(true);
    setLeads([]);
    fetchLeads(sanitized, 0, true);
  }
}, [location.search]);


  useEffect(() => {
    const handleScroll = () => {
      const nearBottom =
        window.innerHeight + window.scrollY >= document.body.offsetHeight - 100;

      if (
        nearBottom &&
        !isLoading &&
        hasMore &&
        !searching &&
        !isManualSearch
      ) {
        fetchLeads(keyword, offset + limit);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isLoading, hasMore, searching, isManualSearch, keyword, offset]);

  const handleSearch = () => {
    setIsManualSearch(true); // flag that this is a search
    setSearching(true);
    setOffset(0);
    setHasMore(true);
    setLeads([]);
    const sanitized = keyword.trim().replace(/\s+/g, " ");
    fetchLeads(sanitized, 0, true);
  };

  return (
    <>
      <Header />
      <div style={{ paddingTop: "70px", paddingBottom: "70px" }}>
        <div className="d-flex flex-column-fluid">
          <div className="container-fluid px-3 py-3">
            {/* Breadcrumb */}
            <div className="d-flex align-items-center justify-content-between mb-4">
              <ul className="breadcrumb breadcrumb-transparent breadcrumb-dot font-weight-bold mb-0 p-0">
                <li className="breadcrumb-item">
                  <Link to="/home" className="text-muted">
                    Home
                  </Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/pages/crm/CRM" className="text-muted">
                    CRM
                  </Link>
                </li>
                <li className="breadcrumb-item">
                  <span className="text-dark font-weight-bold">View Leads</span>
                </li>
              </ul>
            </div>

            {/* Sticky Toolbar */}
            <div
              className="position-sticky"
              style={{ top: 75, zIndex: 1020, background: "#fff" }}
            >
              <div className="card card-custom shadow-sm mb-6">
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap">
                    <h6 className="mb-3 mb-sm-0">Total Leads: {totalLeads}</h6>

                    <div className="d-flex align-items-center mb-3 mb-sm-0">
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="Search by name, company, or..."
                        style={{ width: "250px" }}
                        value={keyword}
                        onChange={(e) => setKeyword(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            handleSearch(); // Trigger the search when "Enter" is pressed
                          }
                        }}
                      />
                      <button
                        className="btn btn-sm btn-primary font-weight-bold ml-2"
                        onClick={handleSearch}
                      >
                        <i className="fas fa-search"></i>
                      </button>
                    </div>

                    <div className="d-flex gap-2">
                      <Link to="/pages/crm/CRM" className="btn btn-light">
                        <i className="fas fa-arrow-left fa-xs"></i> Back
                      </Link>
                      <button className="btn btn-sm btn-primary font-weight-bold ml-2">
                        <i className="fas fa-filter mr-1"></i> Filter Leads
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Lead Cards */}
            <div className="row mt-4">
              {isLoading ? (
                <>
                  {Array.from({ length: 6 }).map((_, i) => (
                    <div
                      key={i}
                      className="col-xl-6 col-lg-6 col-md-6 col-12 mb-4 d-flex"
                    >
                      <div className="card shadow-sm w-100 p-4">
                        <div className="d-flex mb-3">
                          <div
                            className="rounded-circle mr-3 bg-secondary"
                            style={{
                              width: "50px",
                              height: "50px",
                              opacity: 0.2,
                            }}
                          ></div>
                          <div className="flex-grow-1">
                            <div
                              className="bg-secondary mb-2"
                              style={{
                                height: "12px",
                                width: "60%",
                                opacity: 0.2,
                              }}
                            ></div>
                            <div
                              className="bg-secondary mb-1"
                              style={{
                                height: "10px",
                                width: "40%",
                                opacity: 0.2,
                              }}
                            ></div>
                            <div
                              className="bg-secondary"
                              style={{
                                height: "10px",
                                width: "50%",
                                opacity: 0.2,
                              }}
                            ></div>
                          </div>
                        </div>
                        <div
                          className="bg-secondary mb-2"
                          style={{ height: "10px", width: "70%", opacity: 0.2 }}
                        ></div>
                        <div
                          className="bg-secondary mb-3"
                          style={{ height: "10px", width: "80%", opacity: 0.2 }}
                        ></div>
                        <div
                          className="bg-secondary"
                          style={{ height: "10px", width: "50%", opacity: 0.2 }}
                        ></div>
                      </div>
                    </div>
                  ))}
                </>
              ) : (
                leads.map((lead) => (
                  <div
                    key={lead.id}
                    className="col-xl-6 col-lg-6 col-md-6 col-12 mb-4 d-flex"
                  >
                    <div className="card card-custom shadow-sm px-4 py-4 position-relative h-100 w-100">
                      {/* Eye Icon */}
                      <div
                        className="position-absolute"
                        style={{ top: "1rem", right: "1rem", zIndex: 1 }}
                      >
                        <a
                          href={`/pages/crm/ViewLeadD/${lead.id}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="far fa-eye text-danger icon-lg"></i>
                        </a>
                      </div>
                      {/* Header: Profile & Name */}
                      <div className="d-flex align-items-start mb-3">
                        {lead.profile_pic ? (
                          <img
                            src={
                              lead.profile_pic
                                ? `${API_BASE_URL.replace("/index.php", "")}/${lead.profile_pic}`
                                : ""
                            }
                            alt={lead.full_name}
                            className="rounded-circle mr-4"
                            style={{
                              width: "50px",
                              height: "50px",
                              objectFit: "cover",
                              border: "2px solid #a18dfa",
                            }}
                          />
                        ) : (
                          <div className="symbol symbol-50 mr-4">
                            <span
                              className="symbol-label rounded-circle text-white font-weight-bold d-flex align-items-center justify-content-center"
                              style={{
                                width: "50px",
                                height: "50px",
                                backgroundColor: "#a18dfa",
                                fontSize: "18px",
                              }}
                            >
                              {lead.full_name?.charAt(0).toUpperCase()}
                            </span>
                          </div>
                        )}

                        <div
                          className="flex-grow-1"
                          style={{ marginLeft: "10px" }}
                        >
                          <h5
                            className="text-dark font-weight-bold mb-1"
                            style={{ fontSize: "15px" }}
                          >
                            {lead.full_name}
                          </h5>
                          <div
                            className="text-dark"
                            style={{ fontSize: "13px" }}
                          >
                            <div className="mb-1">{lead.designation}</div>
                            <div className="font-weight-semibold">
                              {lead.company}
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Contact Section */}
                      <div
                        className="mb-2 text-dark"
                        style={{ fontSize: "13px", cursor: "pointer" }}
                        onClick={() => {
                          setSelectedLead(lead);
                          setShowContactModal(true);
                        }}
                      >
                        <i
                          className="fas fa-phone-alt text-primary mr-2"
                          style={{ marginRight: "10px" }}
                        ></i>
                        +91 {lead.mobile}
                        {lead.alt_mobile && ` | +91 ${lead.alt_mobile}`}
                      </div>

                      <div
                        className="mb-3 text-dark"
                        style={{ fontSize: "13px", cursor: "pointer" }}
                        onClick={() => {
                          setSelectedLead(lead);
                          setShowEmailModal(true);
                        }}
                      >
                        <i
                          className="fas fa-envelope text-primary mr-2"
                          style={{ marginRight: "10px" }}
                        ></i>
                        {lead.email}
                        {lead.alt_email && ` | ${lead.alt_email}`}
                      </div>

                      {/* Funnel & Priority Badges */}
                      <div className="d-flex align-items-center flex-wrap mb-3">
                        {lead.funnel_stage && (
                          <span
                            className="badge badge-info font-weight-bold mr-2 mb-2 px-3 py-2"
                            style={{ fontSize: "12px", marginRight: "7px" }}
                          >
                            <i className="fas fa-filter mr-1"></i>{" "}
                            {lead.funnel_stage}
                          </span>
                        )}
                        {lead.priority && (
                          <span
                            className="badge badge-danger font-weight-bold mb-2 px-3 py-2"
                            style={{ fontSize: "12px" }}
                          >
                            {lead.priority} Priority
                          </span>
                        )}
                      </div>

                      {/* Meta Footer */}
                      <div
                        className="d-flex flex-wrap align-items-center text-dark"
                        style={{ fontSize: "13px" }}
                      >
                        <div
                          className="mr-4 mb-2 d-flex align-items-center"
                          style={{ marginRight: "10px" }}
                        >
                          <i
                            className="fas fa-user text-primary"
                            style={{ marginRight: "10px" }}
                          ></i>
                          <strong>Assigned to:</strong>&nbsp;
                          <span className="font-weight-bold">
                            {lead.assigned_to_name || "-"}
                          </span>
                        </div>
                        <div className="mb-2 d-flex align-items-center">
                          <i
                            className="fas fa-user-plus text-primary mr-1"
                            style={{ marginRight: "10px" }}
                          ></i>
                          {lead.created_by_name || "-"}
                          {lead.created_on && (
                            <>
                              &nbsp;|&nbsp;
                              {new Date(lead.created_on).toLocaleDateString(
                                "en-GB",
                                {
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                },
                              )}{" "}
                              {new Date(lead.created_on).toLocaleTimeString(
                                "en-IN",
                                {
                                  hour: "2-digit",
                                  minute: "2-digit",
                                },
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              )}
              {!isLoading && leads.length === 0 && (
                <div className="col-12 text-center text-dark py-10">
                  No leads found matching your search.
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <Modal
        show={showContactModal}
        onHide={() => setShowContactModal(false)}
        centered
      >
        <div className="modal-content rounded-xl shadow p-4">
          <div className="modal-header py-2 border-0">
            <h5 className="modal-title font-weight-bold text-dark">
              Contact Options
            </h5>
            <button
              type="button"
              className="close"
              onClick={() => setShowContactModal(false)}
            >
              <i className="ki ki-close"></i>
            </button>
          </div>
          <div className="modal-body text-center py-3">
            {selectedLead && (
              <>
                {/* Primary Number */}
                <div className="mb-4">
                  <div className="font-weight-bold text-dark mb-2">
                    +91 {selectedLead.mobile}
                  </div>
                  <a
                    href={`tel:+91${selectedLead.mobile}`}
                    className="btn btn-primary font-weight-bold mr-3 px-5"
                    style={{ marginRight: "10px" }}
                  >
                    <i className="fas fa-phone-alt mr-2"></i>Call
                  </a>
                  <a
                    href={`https://wa.me/91${selectedLead.mobile}`}
                    target="_blank"
                    rel="noreferrer"
                    className="btn btn-success font-weight-bold px-5"
                  >
                    <i className="fab fa-whatsapp mr-2"></i>WhatsApp
                  </a>
                </div>

                {/* Alternate Number */}
                {selectedLead.alt_mobile && (
                  <div>
                    <div className="font-weight-bold text-dark mb-2">
                      +91 {selectedLead.alt_mobile}
                    </div>
                    <a
                      href={`tel:+91${selectedLead.alt_mobile}`}
                      className="btn btn-primary font-weight-bold mr-3 px-5"
                      style={{ marginRight: "10px" }}
                    >
                      <i className="fas fa-phone-alt mr-2"></i>Call
                    </a>
                    <a
                      href={`https://wa.me/91${selectedLead.alt_mobile}`}
                      target="_blank"
                      rel="noreferrer"
                      className="btn btn-success font-weight-bold px-5"
                    >
                      <i className="fab fa-whatsapp mr-2"></i>WhatsApp
                    </a>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </Modal>

      <Modal
        show={showEmailModal}
        onHide={() => setShowEmailModal(false)}
        centered
      >
        <div className="modal-content rounded-xl shadow p-4">
          <div className="modal-header py-2 border-0">
            <h5 className="modal-title font-weight-bold text-dark">
              Choose Email
            </h5>
            <button
              type="button"
              className="close"
              onClick={() => setShowEmailModal(false)}
            >
              <i className="ki ki-close"></i>
            </button>
          </div>
          <div className="modal-body text-center py-3">
            {selectedLead?.email && (
              <a
                href={`mailto:${selectedLead.email}`}
                className="btn btn-primary font-weight-bold mb-3 w-100"
              >
                <i className="fas fa-envelope mr-2"></i> {selectedLead.email}
              </a>
            )}
            {selectedLead?.alt_email && (
              <a
                href={`mailto:${selectedLead.alt_email}`}
                className="btn btn-primary font-weight-bold w-100"
              >
                <i className="fas fa-envelope mr-2"></i>{" "}
                {selectedLead.alt_email}
              </a>
            )}
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ViewLeads;
